<template>
  <div class="mr-3 relative">
    <div v-if="selectable">
      <Listbox as="div" v-model="selected">
        <div class="relative mt-1">
          <ListboxButton class="listbox-button">
            <span v-if="selected" class="flex items-center">
              <div v-if="selected.image" class="h-8 w-8 flex-shrink-0 rounded-sm">
                <img :src="selected.image.image_uri" class="h-8 w-8 flex-shrink-0 rounded-sm" />
              </div>
              <div v-else="selected.image" class="h-8 w-8 flex-shrink-0 rounded-sm">
                <img :src="image" class="h-8 w-8 flex-shrink-0 rounded-sm" />
              </div>
              <span class="ml-3 block truncate">
                {{ selected.name }}
              </span>
            </span>
            <span v-else="selected" class="flex items-center">
              <img src="/images/studio.svg" alt="" class="h-8 w-8 flex-shrink-0 rounded-full" />
              <span class="ml-3 block truncate">
                Format auswählen
              </span>
            </span>
            <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
              <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </span>
          </ListboxButton>
          <transition
            leave-active-class="transition ease-in duration-100"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <ListboxOptions class="listbox-options">
              <ListboxOption as="template" v-for="podcast in podcasts" :key="podcast.id" :value="podcast" v-slot="{ active, selected }">
                <li :class="[active ? 'text-white bg-teal-600' : 'text-gray-900', 'relative cursor-pointer select-none py-2 pl-3 pr-9']">
                  <div class="flex items-center">
                    <div v-if="podcast.image" class="h-6 w-6 flex-shrink-0 rounded-sm">
                      <img :src="podcast.image.image_uri" class="h-6 w-6 flex-shrink-0 rounded-sm" />
                    </div>
                    <div v-else="podcast.image" class="h-6 w-6 flex-shrink-0 rounded-sm">
                      <img :src="image" class="h-6 w-6 flex-shrink-0 rounded-sm" />
                    </div>
                    <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                      {{ podcast.name }}
                    </span>
                  </div>
                  <span v-if="selected" :class="[active ? 'text-white' : 'text-teal-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                    <CheckIcon class="h-5 w-5" aria-hidden="true" />
                  </span>
                </li>
              </ListboxOption>
              <hr/>
              <button @click="create" class="listbox-action">
                <div class="flex items-center">
                  <PlusCircleIcon class="h-6 w-6 flex-shrink-0" />
                  <span class="ml-3">
                    Weiteren Podcast anlegen
                  </span>
                </div>
              </button>
            </ListboxOptions>
          </transition>
        </div>
      </Listbox>
    </div>
    <div v-else="selectable">
      <img class="h-8 w-8" src="/images/studio.svg" alt="St. Audio Studio" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const emits = defineEmits(['keydown']);

const store = useStore();
const router = useRouter();

const image = computed(() => '/images/podcast.svg');
const podcasts = computed(() => store.getters['context/podcasts']);
const selectable = computed(() => store.getters['context/selectable']);

const fetch = () => store.getters['context/context'];
const redirect = () => router.push({name: 'dashboard'});
const replace = (value) => store.dispatch('context/select', value);
const update = (value) => replace(value).then(redirect);
const selected = computed({get: fetch, set: update});


const create = () => router.push({name: 'onboarding.show'});
</script>

<style scoped>

.listbox-button
{
  @apply relative py-2 pl-3 pr-10 w-52;
  @apply rounded-md;
  @apply text-left text-white font-semibold shadow-sm sm:text-sm;
  @apply focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500;
  @apply cursor-default;
}

.listbox-options
{
  @apply absolute z-10 mt-1 max-h-60 w-full overflow-auto w-96;
  @apply rounded-md bg-white py-1 text-base shadow-lg focus:outline-none sm:text-sm;
  @apply ring-1 ring-black ring-opacity-5;
}

.listbox-action
{
  @apply relative select-none py-2 pl-3 pr-9 w-full;
  @apply cursor-pointer;
  @apply text-gray-900;
  @apply hover:text-white hover:bg-teal-600
}

</style>
